import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "inputContainer", "container"]

  connect() {
    this.key = "rx_config_rule_saved_searches"
    this.savedSearches = window.RXHelpers.LocalStorage.get(this.key) || []
    if (this.savedSearches.length > 0) {
      this.renderSavedSearches()
    }
  }

  saveSearch() {
    if (window.location.search === "") {
      alert("Please perform a search before saving.") // eslint-disable-line no-alert
      return
    }
    if (this.nameInputTarget.value.trim() === "") {
      alert("Please enter a name for your search.") // eslint-disable-line no-alert
      return
    }
    if (this.savedSearches.length >= 10) {
      alert("You can only save up to 10 searches.") // eslint-disable-line no-alert
      return
    }
    this.savedSearches.push({
      name: this.nameInputTarget.value,
      url: window.location.search
    })
    window.RXHelpers.LocalStorage.save(this.key, this.savedSearches)
    this.nameInputTarget.value = ""
    this.renderSavedSearches()
  }

  deleteSearch(event) {
    const index = event.params.index
    this.savedSearches.splice(index, 1)
    window.RXHelpers.LocalStorage.save(this.key, this.savedSearches)
    this.renderSavedSearches()
  }

  renderSavedSearches() {
    this.containerTarget.innerHTML = ""
    const searchesArray = this.savedSearches.map((search, index) => {
      return `
        <div class="d-flex justify-content-between align-items-center mb-2" data-index="${index}">
          <a href="${window.location.pathname}${search.url}" class="d-block mb-1">${search.name}</a>
          <span class="cursor-pointer" data-action="click->save-search#deleteSearch" data-index-param="${index}" data-delete-icon-slot></span>
        </div>
      `
    })
    const sanitizer = new Sanitizer({
      elements: ["div", "a", "span"],
      attributes: ["href", "class"],
      dataAttributes: true
    });
    this.containerTarget.setHTML(searchesArray.join(""), { sanitizer })

    // The Sanitizer above strips <svg>, and it has to stay: search names are
    // user input. Clone the icon in after it rather than widening the allowlist.
    this.containerTarget.querySelectorAll("[data-delete-icon-slot]").forEach((slot) => {
      const icon = this._iconNode("x")
      if (icon) slot.appendChild(icon)
    })
  }

  _iconNode(name) {
    const template = this.element.querySelector(`template[data-save-search-icon="${name}"]`)
    return template?.content.firstElementChild?.cloneNode(true) || null
  }
}
